import { useEffect } from "react";

// Bottom sheet for the Mobile view. It holds the filter sidebar (passed as children)
// and scrolls inside itself so the page behind stays put.
const LeadListFiltersSheet = ({ leadCount, onClose, children }) => {
  // Lock page scroll while the sheet is open, then put back what was there.
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[250] flex items-end bg-black/40" onClick={onClose}>
      <div
        role="dialog"
        aria-label="Filters"
        className="flex max-h-[85vh] w-full flex-col rounded-t-2xl bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <h2 className="text-lg font-semibold text-text-primary">Filters</h2>
          <button type="button" onClick={onClose} aria-label="Close filters" className="p-1 text-text-secondary">
            &times;
          </button>
        </div>
        <div className="flex-1 overflow-y-auto overscroll-contain px-4 pt-3">{children}</div>
        <div className="border-t border-border p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-lg bg-teal-700 py-3 text-sm font-medium text-white"
          >
            {`Show ${leadCount ?? 0} leads`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadListFiltersSheet;
